import React from 'react'
import Image from '../../../images/sellerpolicies/15.png'

const Your_product_listings_featuring = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Your Product Listings/Featuring</h2>
            <p>Listing the product on their online shops will be the sole duty of the seller itself. During the uploading seller have to provide the correct “Required Product Information”.</p>
            <p>KAAY can Delist any product uploaded by the seller if it’s against any policy of KAAY.</p>
        </div>
      </div>
    </div>
  )
}

export default Your_product_listings_featuring
